import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { LessonMode } from '../../../Constants';
import OptionalImage from '../OptionalImage';
import Guideline from '../tools/Guideline';
import '../../../css/AppletQuestion.scss';
import HtmlComponent from '../HtmlComponent';
import useStyleEvents from '../../../hooks/useStyleEvents';
import PrintQuestionNumber from './PrintQuestionNumber';

const AppletQuestion = observer(({ lessonElementId }) => {
  const {
    lessonManager,
    responseManager,
    toolbarManager
  } = useContext(MobXProviderContext);

  const model = lessonManager.getSlideModel(lessonElementId);
  const textBody = model.questionText || '';

  const lessonElementState = responseManager.getLessonElementState(lessonElementId);

  if (!lessonElementState) {
    return (<div className='applet-question' />);
  }

  useStyleEvents(lessonElementId);

  return (
    <div className='applet-question'>
      {toolbarManager.isGuidelineOpen && <Guideline lessonElementId={lessonElementId} />}
      <div className='test-item-question'>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && <PrintQuestionNumber model={model} />}
        <HtmlComponent htmlStr={textBody} />
      </div>
      <OptionalImage model={model} runtime={true} />
      <div className='test-item-answers'>
        {(lessonManager.playerMode === LessonMode.PRINT_PREVIEW) && (
          <div className='print-line-wrapper'>
            {(lessonManager.isForceTeacher) ? (
              <HtmlComponent htmlStr={model.validation.solution} />
            ) : (
              <>
                <div className='print-line' />
                <div className='print-line' />
                <div className='print-line' />
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
});

export default AppletQuestion;
